export const handleDomain = (code?: string) => {
  if (code) {
    // eslint-disable-next-line no-useless-concat
    return code + "." + "ala8.net";
  }
  return "ala8.net";
};
